import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoutes = () => {
    const isAuthenticated = sessionStorage.getItem("isAuthenticated");
    return isAuthenticated ? <Outlet /> : <Navigate to="/auth/login" />
}

export default ProtectedRoutes;